import createRoute from '@widesk-ui/tools/createRoute';
import UserModel   from '@models/website/UserModel';

const route = createRoute.dashboardFromModel(
	UserModel,
	'UserDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
